module.exports = __webpack_public_path__ + "img/online-alternative-payments.80463b6.png";